import { createI18n } from 'vue-i18n'
import zhCn from './zh/translation.json'
import enUs from './en/translation.json'

export default createI18n({
  locale: localStorage.getItem('lang') === 'zh' || !localStorage.getItem('lang') ? 'zh' : 'en',
  messages: {
    zh: zhCn,
    en: enUs,
  }
})